export const enum blockAccessTypes {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL'
}

export const enum blockModelTypes {
  SCOPE_TOP = 'SCOPE_TOP',
  SCOPE_NORMAL = 'SCOPE_NORMAL'
}

export const blockModelMessages = {
  externalStakeholder: {
    title: {
      limitReached: 'External Stakeholder Limit Reached'
    },
    description: {
      limitReached: (limit: number): any => {
        return `You’ve reached the maximum limit 
                    of ${limit} external stakeholders
                  for your current plan. Upgrade your plan to add more stakeholders and
                  continue expanding your organization network.`;
      }
    }
  },
  facility: {
    title: {
      limitReached: 'Facility Limit Reached'
    },
    description: {
      limitReached: (planType: string, limit: number): any => {
        return `Your ${planType} Plan includes access to ${limit} 
        facility only.<br/>Upgrade your plan to add more facilities.`;
      }
    }
  },
  user: {
    title: {
      limitReached: 'User Limit Reached'
    },
    description: {
      limitReached: (planType: string, limit: number): any => {
        return `Your ${planType} Plan includes access to ${limit} 
          user only.<br/>Upgrade your plan to add more users.`;
      }
    }
  },
  scope: {
    title: {
      unlockMessage(scopeNo: string): string {
        return `Unlock scope ${scopeNo}`;
      },
      genericMessage(scopeNo: string, moduleName: string): string {
        return `Access Scope ${scopeNo} ${moduleName} Insights by Upgrading to Advance`;
      }
    },
    description: {
      message: (subMessage: string): string => {
        return `Align emissions with SDG goals.<br/>
Upgrade to access detailed Scope ${subMessage} data.`;
      }
    }
  }
};
